<section class="common-table">
  <div class="container_wrapper--common-table">
    <div class="center_main--common-table">
      <app-common-wrapper
        [extraExercise]="commonData?.lesson_extra_exercise"
      ></app-common-wrapper>
      <div *ngIf="!allAbsent && commonData" class="common-table__wraper">
        <table class="common_table--common-table">
          <thead class="table_header--common-table">
            <tr>
              <th class="pupil_name--common-table"></th>
              <th class="box_level--common-table" *ngFor="let box of boxes;">
                <span class="box_number">
                  box {{ box.title }}
                </span>
                <div class="box_level" [class.is_extra_exercise]="checkBoxForExtraExercise(box)">
                  {{ box.level }}
                </div>
              </th>
              <th *ngIf="commonData.is_habirint"></th>
              <th *ngIf="commonData.is_habirint"></th>
              <th *ngIf="commonData?.lesson_extra_exercise"></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            <tr>
              <th class="pupil_name--common-table"></th>
              <th class="box_name--common-table" *ngFor="let box of boxes;">
                <div class="box_bgr--common-table">
                  <div class="box_files--common-table">
                    <span *ngFor="let file of box.files">
                      {{ file.str_title }}
                    </span>
                  </div>
                </div>
              </th>
              <th *ngIf="commonData.is_habirint" class="coach__column">Кол-во учеников у которых был коучем</th>
              <th *ngIf="commonData.is_habirint" class="coach__column">Кол-во заданий для которых был коучем</th>
              <th class="extra-exercise__column" *ngIf="commonData?.lesson_extra_exercise">Доп. задание</th>
              <th class="right_amount--common-table">Кол-во прав. реш. заданий</th>
              <th class="percent_error--common-table"><span>%</span><br>ошибок</th>
              <th class="money--common-table">Заработано</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let student of student_results; let studentIndex = index;">
              <td [ngClass]="getPupilStyle(student)" (click)="navigateToPupil(student)" class="fix-column">
                <span class="pupil_number--common-table">{{studentIndex + 1}}. </span>
                <span class="name--common-table">
                  {{ student.name + ' ' + student.surname }}
                </span>
              </td>
              <ng-container *ngFor="let box of boxes">
                <td [ngClass]="getEmptyCellStyle(box.id, student.box_data)" class="adapt-column">
                  <div [ngClass]="getSuccessLevelStyle(box.id, student.box_data)" (click)="showModal(commonModal, box.id, student.box_data, student.id)">
                    {{getData(box.id, student.box_data)}}
                  </div>
                </td>
                <ng-template
                  class="modal fade in"
                  data-backdrop="false"
                  #commonModal>
                  <div class="modal-body" style="padding: 0">
                    <app-common-modal
                      [box]="box"
                      [student_id]="studentId"
                      (shouldClose)="hideModal($event)"
                      *ngIf="boxId && studentId"
                    ></app-common-modal>
                  </div>
                </ng-template>
              </ng-container>
              <td *ngIf="commonData.is_habirint" class="coach__item">
                {{ student.lesson_statistics?.total_coach_students ? student.lesson_statistics?.total_coach_students : "" }}
              </td>
              <td *ngIf="commonData.is_habirint" class="coach__item">
                {{ student.lesson_statistics?.total_coach_exercises_correct ? student.lesson_statistics?.total_coach_exercises_correct : "" }}
                <span *ngIf="student.lesson_statistics?.total_coach_exercises_correct && student.lesson_statistics?.total_coach_exercises_incorrect"> / </span> 
                {{ student.lesson_statistics?.total_coach_exercises_incorrect ? student.lesson_statistics?.total_coach_exercises_incorrect : "" }}
              </td>
              <td class="extra-exercise__row" *ngIf="commonData?.lesson_extra_exercise">
                {{ getExtraData(student.lesson_extra_exercise) }}
              </td>
              <td [ngClass]="getRightStyle(student.lesson_statistics)">
                <div>
                  {{getRightData(student.lesson_statistics)}}
                </div>
              </td>
              <td [ngClass]="getErrorPercentStyle(student.lesson_statistics)">
                <div>
                  {{getErrorPercentData(student.lesson_statistics)}}
                </div>
              </td>
              <td [ngClass]="getMoneyStyle(student.lesson_amount_stat_for_student)">
                <div>
                  {{getMoneyData(student)}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="container not-solving-lesson" *ngIf="allAbsent">
        <h4 style="font-weight: bold; color: #495660;">
          Данные за урок отсутствуют
        </h4>
      </div>
      <app-stat-pagination></app-stat-pagination>
    </div>
  </div>
</section>
